import { BillingCycle } from "@next-platform/client-common-core/user/types";

const getBillingCycleFromPlanId = (planId: string | undefined | null): BillingCycle => {
  if (!planId) {
    return BillingCycle.MONTHLY;
  }
  if (planId.includes("1y")) {
    return BillingCycle.ANNUAL;
  }
  if (planId.includes("3m")) {
    return BillingCycle.QUARTERLY;
  }
  return BillingCycle.MONTHLY;
};

export default getBillingCycleFromPlanId;
